import { definePage } from "@openclaw/uirouter";
import { html } from "lit";
import { routePageSpec } from "../../app-route-paths.ts";

export const page = definePage({
  ...routePageSpec("office"),
  component: () =>
    import("./office-page.ts").then(() => ({
      header: true,
      render: () => html`<openclaw-office-page></openclaw-office-page>`,
    })),
});
